module.exports = __webpack_public_path__ + "img/amx-20.8fbdcd26.jpg";